import React, { useEffect, useMemo, useRef, useState } from "react";
import { useCookies } from 'react-cookie';
import AdminSharedPresetPanel from "./AdminSharedPresetPanel";
import OpenPositionsSnapshotSection from "./OpenPositionsSnapshotSection";
import SymbolSearchPopup from "./SymbolSearchPopup";


export default function SetPage(){

    const [cookies] = useCookies(['uuid']);

    // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
    const[uid,setUID] = useState(0);
    const[nickname,setNickname] = useState('');
    const [isAdminAccess, setIsAdminAccess] = useState(false);

    const [isChecked, setIsChecked] = useState(false);

    const [symbolList, setSymbolList] = useState([]);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupAnchor, setPopupAnchor] = useState(null);
    const [isSymbolMenuOpen, setIsSymbolMenuOpen] = useState(false);
    const [isModeMenuOpen, setIsModeMenuOpen] = useState(false);
    const [isBothMenuOpen, setIsBothMenuOpen] = useState(false);
    const symbolDropdownRef = useRef(null);
    const modeDropdownRef = useRef(null);
    const bothDropdownRef = useRef(null);
    const welfareRatioChangedByUser = useRef(false);
    const didInitSearch = useRef(false);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (symbolDropdownRef.current && !symbolDropdownRef.current.contains(event.target)) {
          setIsSymbolMenuOpen(false);
        }
        if (modeDropdownRef.current && !modeDropdownRef.current.contains(event.target)) {
          setIsModeMenuOpen(false);
        }
        if (bothDropdownRef.current && !bothDropdownRef.current.contains(event.target)) {
          setIsBothMenuOpen(false);
        }
      };

      const handleEscapeKey = (event) => {
        if (event.key === 'Escape') {
          setIsSymbolMenuOpen(false);
          setIsModeMenuOpen(false);
          setIsBothMenuOpen(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscapeKey);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEscapeKey);
      };
    }, []);
  
    useEffect(() => {
      if (!cookies.uuid) {
        redirectToLogin();
        return;
      }

      // uuid가 있을 때 서버로 요청 (authmiddleware가 처리)
      fetchUserInfo();
    }, [cookies.uuid]);

    const redirectToLogin = () => {
      alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
      window.location.href = '/LoginAts';
    };
    
    const fetchUserInfo = () => {
      fetch(`/circleversion_selected`, { credentials: 'include' })
        .then(async (res) => {
          const data = await res.json().catch(() => ({}));
          if (!res.ok) {
            throw new Error(data.message || '페이지 접근 권한 확인에 실패했습니다.');
          }
          return data;
        })
        .then((data) => {
          const adminAccess = Boolean(data?.is_admin_access);
          setIsAdminAccess(adminAccess);
          if (data.message !== 'ok') {
            alert(data.message);
            window.location.href = adminAccess ? '/Adminpage' : '/SelectPage';
            return null;
          }
          return fetch('/GetUserInfo', { credentials: 'include' });
        })
        .then((res) => {
          if (!res) {
            return null;
          }
          return res.json();
        })
        .then((user) => {
          if (!user) {
            return;
          }
          setIsAdminAccess(Boolean(user.is_admin_access));
          setUID(user.uid);
          setNickname(user.nickname);
          fetchLists();
        })
        .catch(() => {
          redirectToLogin();
        });
    };
    
    // selectedlevel, entry, waiting list 받아오기
    const fetchLists = () => {
      fetch(`/startcheck/searchlevel`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          if(data[0].super_user === "8"){
            setLevelCheck(data[0].super_user);  
          }else{
            setLevelCheck(data[0].selectedLevel);
          }
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });

      fetch(`/startcheck_circle/list_entry`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, e_items, setE_Items);
        })
        .catch(error => {
          console.error('Entry List 가져오기 오류:', error);
          alert(error);
        });
  
      fetch(`/startcheck_circle/list_wait`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          updateList(data, w_items, setW_Items);
        })
        .catch(error => {
          console.error('Waiting List 가져오기 오류:', error);
          alert(error);
        });
    };
  
    const updateList = (data, list, setList) => {
      for (let i = 0; i < data.length; i++) {
        if (!isItemInList(data[i].symbol, list)) {
          setList(prevList => [...prevList, data[i].symbol]);
        }
      }
    };

    const isItemInList = (item, list) => {
      return list.includes(item);
    };

    const[seed,setSeed] = useState('basic');

    const[mode,setMode] = useState('normal');
    const [both_mode, setBothMode] = useState('single');

    const[auto_count,setSymbolCount] = useState(3);
    const[top_bottom,setTopBottom] = useState('top');
    const[fluctuation,setFluctuation] = useState(0);

    const[funding_rate,setFundingRate] = useState('disable');
    const[f_percent_low,setFpercentLow] = useState(-100);
    const[f_percent_high,setFpercentHigh] = useState(0);

    const[symbol,setSymbol] = useState('default');
    const selectableSymbols = useMemo(
      () => Array.from(new Set(symbolList.filter((sym) => sym && sym !== 'default'))),
      [symbolList]
    );
    const currentSymbolLabel = symbol && symbol !== 'default' ? symbol : 'symbol select';
    const MODE_OPTIONS = [
      { value: 'normal', label: '일반모드 셋팅' },
      { value: 'auto', label: '자동모드 셋팅' },
    ];
    const currentModeLabel = MODE_OPTIONS.find((option) => option.value === mode)?.label || '일반모드 셋팅';

    const BOTH_MODE_OPTIONS = [
      { value: 'single', label: 'single mode' },
      { value: 'double', label: 'double mode' },
    ];
    const currentBothModeLabel = BOTH_MODE_OPTIONS.find((option) => option.value === both_mode)?.label || 'single mode';
    const isAutoMode = mode === 'auto';
    const autoDisabled = mode !== 'auto';
    const autoFieldStyle = autoDisabled
      ? { filter: 'blur(5px)', pointerEvents: 'none', opacity: 0.5 }
      : {};

    useEffect(() => {
      if (mode === 'auto') {
        setIsSymbolMenuOpen(false);
      }
    }, [mode]);

    const[total_benefit_start,setTotalBenefitStart] = useState(0);
    const isTotalBenefitRunning = Number(total_benefit_start) === 1;

    const[leverage_info, setLeverage] = useState(20);

    const[sensitivity,setSensitivity] = useState(2);
    const[atr_period,setAtrPeriod] = useState(2);

    const[entry_mode,setEntryMode] = useState('kinpoint');
    const[hedge_mode,setHedgeMode] = useState('kinpoint');

    const[entry_continue,setEntryContinue] = useState('disable');

    const[entry_standard,setEntryStandard] = useState('disable');
    const[candle_standard,setCandleStandard] = useState('4h');
    const[candle_type_standard, setCandleTypeStandard] = useState('haikin');
    const[sensitivity_standard,setSensitivityStandard] = useState(2);
    const[atr_period_standard,setAtrPeriodStandard] = useState(2);

    const[ema_standard,setEmaStandard] = useState(200);
    const[ema_losscut,setEmaLosscut] = useState('no');
    
    //////////////////////////////////////////////////////////
    const[circle_candle,setCircleCandle] = useState('5m');
    const[sensitivity_circle,setSensitivityCircle] = useState(1);
    const[atr_period_circle,setAtrPeriodCircle] = useState(20);
    const[candle_type_circle, setCandleTypeCircle] = useState('haikin');
    const[circle_checking,setCircleChecking] = useState(-1);
    const[circle_close_mode,setCircleCloseMode] = useState('kinpoint');
    ///////////////////////////////////////////////////
    
    const[entry_candle,setEntryCandle] = useState('5m');

    const[entry_checking,setEntryChecking] = useState(-1);
    const[standard_checking,setStandardChecking] = useState(-1);
    const[close_checking,setCloseChecking] = useState(-1);

    const[close_mode,setCloseMode] = useState('kinpoint');

    const[sensitivity_hedge,setSensitivityHedge] = useState(2);
    const[atr_period_hedge,setAtrPeriodHedge] = useState(1);

    const[hedge_candle,setHedgeCandle] = useState('5m');
    const[candle_type_hedge, setCandleTypeHedge] = useState('haikin');
    const[hedge_checking,setHedgeChecking] = useState(-1);

    //////////////////////////////////////////////////////////

    const[close_candle,setCloseCandle] = useState('15m');
    const[sensitivity_close,setSensitivityClose] = useState(1);
    const[atr_period_close,setAtrPeriodClose] = useState(1);

    const[direction,setDirection] = useState('long');

    //////////////////////////////////////////////////////////

    const[candle_type_entry, setCandleTypeEntry] = useState('haikin');
    const[candle_type_close, setCandleTypeClose] = useState('haikin');

    const[benefit_ratio,setBenefitRatio] = useState(0.3);

    const[trigger_mode,setTriggerMode] = useState('no');
    const[trigger_ratio,setTriggerRatio] = useState(1);

    const[main_balance,setMainBalance] = useState(0);
    const[second_balance,setSecondBalance] = useState(0);

    const[total_benefit_usdt,setTotalBenefitUsdt] = useState(0);
    const[total_benefit_usdt_obj,setTotalBenefitUsdtObj] = useState(0);
    const[total_benefit_count,setTotalBenefitCount] = useState(0);
    const[total_current_count,setTotalCurrentCount] = useState(0);
    const[entry_usdt_1, setEntryUsdt_1] = useState(10);
    const[welfare_mode, setWelfareMode] = useState('disable');
    const[welfare_ratio, setWelfareRatio] = useState(100);

    const[circle_mode,setCircleMode] = useState('entry');
    const[circle_rate,setCircleRate] = useState(50);

    const[double_benefit, setDoubleBenefit] = useState(0);
    const[double_pnl, setDoublePnl] = useState(0);

    const[totalpnl,setTotalPnl] = useState(0);

    const[hedge_continue,setHedgeContinue] = useState('no');

    //////////////////////////////////////////////////////////

    const[symbolCountValid, setSymbolCountValid] = useState(true);
    const[fPercentLowValid, setFpercentLowValid] = useState(true);
    const[fPercentHighValid, setFpercentHighValid] = useState(true);
    const[fluctuationValid, setFluctuationValid] = useState(true);
    
    const[leverageValid, setLeverageValid] = useState(true);

    const[emaStandardValid, setEmaStandardValid] = useState(true);

    const[sensitivityStandardValid, setSensitivityStandardValid] = useState(true);
    const[atrperiodStandardValid, setAtrperiodStandardValid] = useState(true);

    const[sensitivityValid, setSensitivityValid] = useState(true);
    const[atrperiodValid, setAtrperiodValid] = useState(true);
  
    const[sensitivityHedgeValid, setSensitivityHedgeValid] = useState(true);
    const[atrperiodHedgeValid, setAtrperiodHedgeValid] = useState(true);

    const[sensitivityCircleValid, setSensitivityCircleValid] = useState(true);
    const[atrperiodCircleValid, setAtrperiodCircleValid] = useState(true);

    const[sensitivityCloseValid, setSensitivityCloseValid] = useState(true);
    const[atrperiodCloseValid, setAtrperiodCloseValid] = useState(true);

    const[benefit_ratioratioValid, setBenefitRatioratioValid] = useState(true);

    const[total_benefit_usdtValid, setTotalBenefitusdtValid] = useState(true);
    const[total_benefit_countValid, setTotalBenefitCountValid] = useState(true);

    const[trigger_ratioValid, setTriggerRatioValid] = useState(true);

    const[welfare_ratioValid, setWelfareRatioValid] = useState(true);

    const[entryusdtValid_1,setEntryUsdtValid_1] = useState(true);

    const[circle_rateValid,setCircleRateValid] = useState(true);

    const[double_benefitValid, setDoubleBenefitValid] = useState(true);

    const[setlevel, setLevelCheck] = useState(0);

    const[notAllow, setNotAllow] = useState(true);

    const[e_items, setE_Items] = useState([]);
    const[w_items, setW_Items] = useState([]);

    const toggleModeMenu = () => {
      setIsModeMenuOpen((prev) => !prev);
    };

    const toggleSymbolMenu = () => {
      if (mode === 'auto') {
        return;
      }
      setIsSymbolMenuOpen((prev) => !prev);
    };

    const handleModeSelect = (value) => {
      setMode(value);
      setIsModeMenuOpen(false);
      if (value === 'auto') {
        setSymbol('default');
        onClickSearch_auto();
      }
    };

    const handleSymbolSelect = (value) => {
      if (mode === 'auto') {
        return;
      }
      setSymbol(value);
      if (value && value !== 'default') {
        onClickSearch(value);
      }
      setIsSymbolMenuOpen(false);
    };

    const toggleBothMenu = () => {
      setIsBothMenuOpen((prev) => !prev);
    };

    const handleBothMenuSelect = async (value) => {
      if (value === "double") {
        const valid = await validateSecondApi();
        if (!valid) {
          setIsBothMenuOpen(false);
          return;
        }
      }
      handleBothMode(value);
      setIsBothMenuOpen(false);
    };

    const handleCheckboxChange = (event) => {
      setIsChecked(event.target.checked);
    };

    const applyTotalBenefitStart = (value) => {
      if (value !== undefined && value !== null) {
        setTotalBenefitStart(value);
      }
    };

    const[trade_start,setTradeStart] = useState(false);
    const[benefit_stop,setBenefit_stop] = useState(false);
    const[benefit_cancel,setBenefit_cancel] = useState(false);

    const[currentCoin_stop,setCurrentCoin_stop] = useState(false);
    const[allCoin_stop,setAllCoin_stop] = useState(false);

    const[end,setEnd] = useState(false);
    
    // 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //

    const validateSecondApi = async () => {
      try {
        const response = await fetch("/hedge/validate-second");
        const text = await response.text();
        let payload;
        try {
          payload = JSON.parse(text);
        } catch {
          payload = { message: text };
        }
        if (!response.ok || !payload?.ok) {
          throw new Error(payload.message || "SelectPage에서 유효한 2nd API 키를 등록하세요.");
        }
        if (payload.message) {
          alert(payload.message);
        }
        return true;
      } catch (error) {
        console.error(error);
        alert(error.message || "SelectPage에서 유효한 2nd API 키를 등록하세요.");
        return false;
      }
    };

    const handleBothMode = (input) => {
      const nextValue = typeof input === 'string' ? input : input?.target?.value;
      if (!nextValue) {
        return;
      }
      setBothMode(nextValue);
    };

    const handleSymbolCount = (e) => {
      const newcount = e.target.value.trim();
      setSymbolCount(newcount);
        const regex = 
        /^\d*$/;
        if (regex.test(newcount)) {
          setSymbolCountValid(true);
          } 
        else {
          setSymbolCountValid(false);
          }
        };

    const handleTopBotton = (e) => {
      setTopBottom(e.target.value);
        };

    const handleFundingRate = (e) => {
      setFundingRate(e.target.value);
        };

    const handleFpercentLow = (e) => {
      const newPercent = e.target.value.trim();
      setFpercentLow(newPercent);

      const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
      if (regex.test(newPercent)) {
        setFpercentLowValid(true);
      } else {
        setFpercentLowValid(false);
      }
    };

    const handleFpercentHigh = (e) => {
      const newPercent = e.target.value.trim();
      setFpercentHigh(newPercent);

      const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
      if (regex.test(newPercent)) {
        setFpercentHighValid(true);
      } else {
        setFpercentHighValid(false);
      }
    };

    const handleFluctuation = (e) => {
      const newPercent = e.target.value.trim();
      setFluctuation(newPercent);

      const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
      if (regex.test(newPercent)) {
        setFluctuationValid(true);
      } else {
        setFluctuationValid(false);
      }
    };

    const handleEntryMode = (e) => {
      setEntryMode(e.target.value);
        };
    
    const handleHedgeMode = (e) => {
      setHedgeMode(e.target.value);
        };

    const handleEntryCandle = (e) => {
      setEntryCandle(e.target.value);
        };

    const handleEntryContinue = (e) => {
      setEntryContinue(e.target.value);
        };
    
    const handleEntryStandard = (e) => {
      setEntryStandard(e.target.value);
    };

    const handleCandleStandard = (e) => {
      setCandleStandard(e.target.value);
    };

    const handleCandleTypeStandard = (e) => {
      setCandleTypeStandard(e.target.value);
    };

    const handleEmaLosscut = (e) => {
      setEmaLosscut(e.target.value);
        };
      
    const handleEntryChecking = (e) => {
      setEntryChecking(e.target.value);
        };

    const handleStandardChecking = (e) => {
      setStandardChecking(e.target.value);
        };

    const handleCircleChecking = (e) => {
      setCircleChecking(e.target.value);
        };

    const handleCloseChecking = (e) => {
      setCloseChecking(e.target.value);
        };

    const handleCircleCloseMode = (e) => {
      setCircleCloseMode(e.target.value);
        };

    const handleCloseMode = (e) => {
      setCloseMode(e.target.value);
        };

    const handleCircleCandle = (e) => {
      setCircleCandle(e.target.value);
        };

    const handleCloseCandle = (e) => {
      setCloseCandle(e.target.value);
        };

    const handleHedgeChecking = (e) => {
      setHedgeChecking(e.target.value);
        };
            
    const handleHedgeCandle = (e) => {
      setHedgeCandle(e.target.value);
        };
    
    const handleDirection = (e) => {
      setDirection(e.target.value);
        };
    
    const handleCandleTypeEntry = (e) => {
      setCandleTypeEntry(e.target.value);
        };

    const handleCandleTypeHedge = (e) => {
      setCandleTypeHedge(e.target.value);
        };

    const handleCandleTypeCircle = (e) => {
      setCandleTypeCircle(e.target.value);
        };

    const handleCandleTypeClose = (e) => {
      setCandleTypeClose(e.target.value);
        };
    
    const handleCircleMode = (e) => {
      setCircleMode(e.target.value);
        };

    const handleHedgeContinue = (e) => {
      setHedgeContinue(e.target.value);
        };
  
    const handleTriggerMode = (e) => {
      setTriggerMode(e.target.value);
        };

    const handleWelfareMode = (e) => {
      setWelfareMode(e.target.value);
        };

    const handleLeverage = (e) => {
      const newLeverage = e.target.value.trim();
      setLeverage(newLeverage);
        const regex = 
        /^\d*$/;
        if (regex.test(newLeverage)) {
          setLeverageValid(true);
          } 
        else {
          setLeverageValid(false);
          }
        };

    const handleSensitivity = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivity(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityValid(true);
          } 
        else {
          setSensitivityValid(false);
          }
        };
    
    const handleAtrperiod = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriod(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodValid(true);
          } 
        else {
          setAtrperiodValid(false);
          }
        };

    const handleEmaStandard = (e) => {
      const newemastandard = e.target.value.trim();
      setEmaStandard(newemastandard);
        const regex = 
        /^\d*$/;
        if (regex.test(newemastandard)) {
          setEmaStandardValid(true);
          } 
        else {
          setEmaStandardValid(false);
          }
        };

    const handleSensitivityStandard = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivityStandard(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityStandardValid(true);
          } 
        else {
          setSensitivityStandardValid(false);
          }
        };
    
    const handleAtrperiodStandard = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriodStandard(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodStandardValid(true);
          } 
        else {
          setAtrperiodStandardValid(false);
          }
        };

    const handleSensitivityHedge = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivityHedge(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityHedgeValid(true);
          } 
        else {
          setSensitivityHedgeValid(false);
          }
        };
    
    const handleAtrperiodHedge = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriodHedge(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodHedgeValid(true);
          } 
        else {
          setAtrperiodHedgeValid(false);
          }
        };

    const handleSensitivityCircle = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivityCircle(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityCircleValid(true);
          } 
        else {
          setSensitivityCircleValid(false);
          }
        };
    
    const handleAtrperiodCircle = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriodCircle(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodCircleValid(true);
          } 
        else {
          setAtrperiodCircleValid(false);
          }
        };

    const handleSensitivityClose = (e) => {
      const newSensitivity = e.target.value.trim();
      setSensitivityClose(newSensitivity);
        const regex = 
        /^\d+$/;
        if (regex.test(newSensitivity)) {
          setSensitivityCloseValid(true);
          } 
        else {
          setSensitivityCloseValid(false);
          }
        };
    
    const handleAtrperiodClose = (e) => {
      const newdata = e.target.value.trim();
      setAtrPeriodClose(newdata);
        const regex = 
        /^\d+$/;
        if (regex.test(newdata)) {
          setAtrperiodCloseValid(true);
          } 
        else {
          setAtrperiodCloseValid(false);
          }
        };

    const handleBenefitratio = (e) => {
      const newBenefitratio = e.target.value.trim();
      setBenefitRatio(newBenefitratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newBenefitratio)) {
          setBenefitRatioratioValid(true);
          } 
        else {
          setBenefitRatioratioValid(false);
          }
        };

    const handleCircleRatio = (e) => {
      const newCircleratio = e.target.value.trim();
      setCircleRate(newCircleratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newCircleratio)) {
          setBenefitRatioratioValid(true);
          } 
        else {
          setBenefitRatioratioValid(false);
          }
        };

    const handleTriggerratio = (e) => {
      const newTriggerratio = e.target.value.trim();
      setTriggerRatio(newTriggerratio);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newTriggerratio)) {
          setTriggerRatioValid(true);
          } 
        else {
          setTriggerRatioValid(false);
          }
        };
    
    const handleWelfareRatio = (e) => {
      const newWelfareRatio = e.target.value.trim();
      setWelfareRatio(newWelfareRatio);
      welfareRatioChangedByUser.current = true;
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newWelfareRatio)) {
          setWelfareRatioValid(true);
          } 
        else {
          setWelfareRatioValid(false);
          }
        };
    
    const handleTotalBenefitCount = (e) => {
      const newTotalBenefitCount = e.target.value.trim();
      setTotalBenefitCount(newTotalBenefitCount);
        const regex = 
        /^\d+$/;
        if (regex.test(newTotalBenefitCount)) {
          setTotalBenefitCountValid(true);
          } 
        else {
          setTotalBenefitCountValid(false);
          }
        };
    
    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////

    // 진입 USDT 유효성 검사 //// 진입 USDT 유효성 검사 //// 진입 USDT 유효성 검사 //
    const handleEntryUsdt_1 = (e) => {
      const newEntryUsdt = e.target.value.trim();
      setEntryUsdt_1(newEntryUsdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntryUsdt)) {
          setEntryUsdtValid_1(true);
          } 
        else {
          setEntryUsdtValid_1(false);
          }
        };
    
    const handleDoubleBenefit = (e) => {
      const newEntrybenefit = e.target.value.trim();
      setDoubleBenefit(newEntrybenefit);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newEntrybenefit)) {
          setDoubleBenefitValid(true);
          } 
        else {
          setDoubleBenefitValid(false);
          }
        };
    
    const handleTotalBenefitusdt = (e) => {
      const newTotalBenefitusdt = e.target.value.trim();
      setTotalBenefitUsdt(newTotalBenefitusdt);
        const regex = 
        /^\d*\.?\d*$/;
        if (regex.test(newTotalBenefitusdt)) {
          setTotalBenefitusdtValid(true);
          } 
        else {
          setTotalBenefitusdtValid(false);
          }
        };
        
    const handleAddSymbol = (symbol) => {
      const confirmed = window.confirm(`${symbol}을 리스트에 추가할까요?`);
      if (confirmed) {
      fetch(`/add_user_symbols_circle_front?symbol=${symbol}`)
      .then(res => res.json())
      .then(data => {
        if (data.msg) {
            alert(data.msg); // msg가 존재할 때만 출력
            return;
          }
        setSymbolList(data.signal)
      })
      .catch(err => console.error(err));
      }
    };

    const deleteSymbol = (symbol) => {
      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      const confirmed = window.confirm(`${symbol}이 포지션이 걸려 있다면 리스트에서 삭제 후 수동으로 포지션 정리해주세요! ${symbol}을 삭제하시겠습니까?`);
      if (confirmed) {
      fetch(`/delete_user_symbols_circle?symbol=${symbol}`)
      .then(res => res.json())
      .then(data => setSymbolList(data.signal))
      .catch(err => console.error(err));
      removeListItem(symbol, setE_Items);
      removeListItem(symbol, setW_Items);
      setSymbol('default')
      }
    };

    const handleOpenPopup = (event) => {
      const rect = event.currentTarget.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const popupWidth = 300;
      const popupHeight = 320;

      const desiredTop = rect.top + scrollTop - popupHeight - 16;
      const top = Math.max(scrollTop + 20, desiredTop);
      const minLeft = scrollLeft + 16;
      const maxLeft = scrollLeft + viewportWidth - popupWidth - 16;
      const candidateLeft = rect.left + scrollLeft;
      const left = Math.min(Math.max(candidateLeft, minLeft), maxLeft);

      setPopupAnchor({ top, left });
      setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
      setIsPopupOpen(false);
      setPopupAnchor(null);
    };        

    const addListItem = (newItem, listSetter) => {
      listSetter(prevList => [...prevList, newItem]);
    };

    const removeListItem = (itemName, listSetter) => {
      listSetter(prevList => prevList.filter(item => item !== itemName));
    };
    
    const onClickCoin = (coin) => {
      setSymbol(coin);
      onClickSearch(coin);
    }

    useEffect(() => {

      if(symbolCountValid && fPercentLowValid && fPercentHighValid && fluctuationValid && leverageValid && emaStandardValid &&
        sensitivityValid && atrperiodValid && sensitivityStandardValid && atrperiodStandardValid && sensitivityCloseValid &&
        atrperiodCloseValid && sensitivityHedgeValid && atrperiodHedgeValid && sensitivityCircleValid && atrperiodCircleValid &&
        benefit_ratioratioValid && entryusdtValid_1 && circle_rateValid && trigger_ratioValid && double_benefitValid && total_benefit_usdtValid && total_benefit_countValid && welfare_ratioValid
        ) {
        setNotAllow(false);
        return;
      }
      setNotAllow(true);
    }, [symbolCountValid, fPercentLowValid, fPercentHighValid, fluctuationValid, leverageValid, emaStandardValid,
       sensitivityValid, atrperiodValid, sensitivityStandardValid, atrperiodStandardValid, sensitivityCloseValid,
       atrperiodCloseValid, sensitivityHedgeValid, atrperiodHedgeValid, sensitivityCircleValid, atrperiodCircleValid,
       benefit_ratioratioValid, entryusdtValid_1, circle_rateValid, trigger_ratioValid, double_benefitValid, total_benefit_usdtValid, total_benefit_countValid, welfare_ratioValid
      ]);

    useEffect(() => {
        fetch(`/get_user_symbols_circle`)
        .then(res => res.json())
        .then(data => setSymbolList(data.signal))
        .catch(err => console.error(err));
    },[symbol,uid]);

    useEffect(() => {
      if (entry_standard !== 'able' && direction === 'auto') {
        setDirection('long');   // 강제 변경
      }
    }, [entry_standard]);

    useEffect(() => {
      if (didInitSearch.current) return;
      if (!uid) return;
      if (setlevel === 0 || setlevel === '0') return;
      didInitSearch.current = true;
      onClickSearch('default');
    }, [uid, setlevel]);

    useEffect(() => {
      if (!welfareRatioChangedByUser.current) return; // 사용자 입력이 아닌 경우 스킵
      if (main_balance === 0 || second_balance === 0) {
        alert('메인 잔고 또는 세컨드 잔고가 0원입니다. 잔고를 확인하고 진행하세요!');
        return;
      }
      const ratio = parseFloat(welfare_ratio);
      setEntryUsdt_1((main_balance + second_balance) * ratio / 100);
    }, [welfare_ratio, main_balance, second_balance]);

    const onClickSamaria_check = () => {
      window.open('/SamariaSignals', '_blank');
      return;
    }

    const onClickSearch_auto = () => {
      fetch(`/setdata_first_circle`)
      .then((response) => {
        if(!response.ok) {
          throw new Error('400 아니면 500 에러남');
        }
        return response.json()
      })
      .then((result) => {
        if (!result || result.length === 0) {
        console.log("데이터가 비어있음, 그냥 넘어감");
        return; // 아무것도 안 함
      }

        const data = result[0]; // 안전하게 변수로 받음
        console.log('db에서 성공적으로 데이터 받아옴');

        setBothMode(data.both_mode);
        setSymbolCount(data.auto_count);
        setTopBottom(data.top_bottom);
        setFluctuation(data.fluctuation)
        setFundingRate(data.funding_rate);
        setFpercentLow(data.f_percent_low);
        setFpercentHigh(data.f_percent_high);

        setEntryMode(data.entry_mode);
        setHedgeMode(data.hedge_mode);
        setLeverage(data.leverage_info);
        setEntryCandle(data.entry_candle);
        setCloseCandle(data.close_candle);

        setEntryChecking(data.entry_checking);
        setStandardChecking(data.standard_checking);
        setCloseChecking(data.close_checking);

        setCloseMode(data.close_mode);

        setSensitivity(data.sensitivity);
        setAtrPeriod(data.atr_period);

        setEntryContinue(data.entry_continue);
        setEntryStandard(data.entry_standard);
        setEmaStandard(result[0].ema_standard);
        setEmaLosscut(result[0].ema_losscut);
        setCandleStandard(data.candle_standard);
        setCandleTypeStandard(data.candle_type_standard);
        setSensitivityStandard(data.sensitivity_standard);
        setAtrPeriodStandard(data.atr_period_standard);

        setSensitivityHedge(data.sensitivity_hedge);
        setAtrPeriodHedge(data.atr_period_hedge);
        setHedgeCandle(data.hedge_candle);
        setCandleTypeHedge(data.candle_type_hedge);
        setHedgeChecking(data.hedge_checking);

        setCircleCandle(data.circle_candle);
        setSensitivityCircle(data.sensitivity_circle);
        setAtrPeriodCircle(data.atr_period_circle);
        setCandleTypeCircle(data.candle_type_circle);
        setCircleChecking(data.circle_checking);
        setCircleCloseMode(data.circle_close_mode);
        
        setSensitivityClose(data.sensitivity_close);
        setAtrPeriodClose(data.atr_period_close);
        
        setDirection(data.direction);

        setBenefitRatio(data.benefit_ratio);

        setTriggerMode(data.trigger_mode);
        setTriggerRatio(data.trigger_ratio);

        setWelfareMode(data.welfare_mode);
        setWelfareRatio(data.welfare_ratio);
        setEntryUsdt_1(data.entry_usdt_1);

        setCircleMode(data.circle_mode);
        setCircleRate(data.circle_rate);

        setDoubleBenefit(data.double_benefit);

        setTotalBenefitUsdt(data.total_benefit_usdt);
        setTotalBenefitUsdtObj(data.total_benefit_usdt_obj);
        setTotalBenefitCount(data.total_benefit_count);
        setTotalCurrentCount(data.total_current_count);
        applyTotalBenefitStart(data.total_benefit_start);

        setCandleTypeEntry(data.candle_type_entry);
        setCandleTypeClose(data.candle_type_close);

      })
      .catch((error) => {
        console.error('에러남:', error.message || error);
      })
    }

    const onClickSearch = (symbol) => {
      let urlName
      const str = symbol;
      console.log(str);
      if(str === 'default'){
        urlName = 'default'
      }else{
        const index = str.indexOf('/');
        urlName = str.substring(0,index);
      }  
      fetch(`/setdata_circle/${urlName}/${setlevel}`)
      .then((response) => {
        if(!response.ok) {
          throw new Error('400 아니면 500 에러남');
        }
        return response.json()
      })
      .then((result) => {
        const data = result[0]; // 안전하게 변수로 받음
        console.log('db에서 성공적으로 데이터 받아옴');
        setBothMode(data.both_mode);
        setEntryMode(data.entry_mode);
        setHedgeMode(data.hedge_mode);
        setLeverage(data.leverage_info);
        setEntryCandle(data.entry_candle);
        setCloseCandle(data.close_candle);

        setEntryChecking(data.entry_checking);
        setStandardChecking(data.standard_checking);
        setCloseChecking(data.close_checking);

        setCloseMode(data.close_mode);

        setSensitivity(data.sensitivity);
        setAtrPeriod(data.atr_period);

        setEntryContinue(data.entry_continue);
        setEntryStandard(data.entry_standard);
        setEmaStandard(result[0].ema_standard);
        setEmaLosscut(result[0].ema_losscut);
        setCandleStandard(data.candle_standard);
        setCandleTypeStandard(data.candle_type_standard);
        setSensitivityStandard(data.sensitivity_standard);
        setAtrPeriodStandard(data.atr_period_standard);

        setSensitivityHedge(data.sensitivity_hedge);
        setAtrPeriodHedge(data.atr_period_hedge);
        setHedgeCandle(data.hedge_candle);
        setCandleTypeHedge(data.candle_type_hedge);
        setHedgeChecking(data.hedge_checking);

        setCircleCandle(data.circle_candle);
        setSensitivityCircle(data.sensitivity_circle);
        setAtrPeriodCircle(data.atr_period_circle);
        setCandleTypeCircle(data.candle_type_circle);
        setCircleChecking(data.circle_checking);
        setCircleCloseMode(data.circle_close_mode);
        
        setSensitivityClose(data.sensitivity_close);
        setAtrPeriodClose(data.atr_period_close);
        
        setDirection(data.direction);

        setBenefitRatio(data.benefit_ratio);

        setTriggerMode(data.trigger_mode);
        setTriggerRatio(data.trigger_ratio);

        setWelfareMode(data.welfare_mode);
        setWelfareRatio(data.welfare_ratio);
        setEntryUsdt_1(data.entry_usdt_1);

        setCircleMode(data.circle_mode);
        setCircleRate(data.circle_rate);

        setDoubleBenefit(data.double_benefit);

        setTotalBenefitUsdt(data.total_benefit_usdt);
        setTotalBenefitUsdtObj(data.total_benefit_usdt_obj);
        setTotalBenefitCount(data.total_benefit_count);
        setTotalCurrentCount(data.total_current_count);
        applyTotalBenefitStart(data.total_benefit_start);

        setCandleTypeEntry(data.candle_type_entry);
        setCandleTypeClose(data.candle_type_close);

        setTradeStart(data.trade_start);
        setBenefit_stop(data.current_symbol_stop);
        setCurrentCoin_stop(data.current_coin_clear);
        setAllCoin_stop(data.all_coin_clear);

        setTotalPnl(data.totalpnl);
        setHedgeContinue(data.hedge_continue);

        const e_checklist = isItemInList(data.symbol, e_items);
        const w_checklist = isItemInList(data.symbol, w_items);
        
        if(str !== 'default'){
          result.forEach(item => {
            // console.log('item',item)
            if ((item.trade_start === 1 || item.trade_start === '1') && e_checklist === false) {
              addListItem(item.symbol, setE_Items);
            }
            if ((item.trade_start === 0 || item.trade_start === '0') && e_checklist === true) {
              removeListItem(item.symbol, setE_Items);
            }
          
            // Waiting coin 리스트 삽입 및 삭제
            if ((item.current_symbol_stop === 1 || item.current_symbol_stop === '1') && w_checklist === false) {
              addListItem(item.symbol, setW_Items);
            }
            if ((item.current_symbol_stop === 0 || item.current_symbol_stop === '0') && w_checklist === true) {
              removeListItem(item.symbol, setW_Items);
            }
          });
        };

        console.log('e_items',e_items);
        console.log('e_checklist',e_checklist);
      })
      .catch((error) => {
        console.log('에러남');
      })
    }

    const onClickAutoStart = () => {

      let confirmed = false

      confirmed = window.confirm('CIRCLE 버전 자동매매를 시작하시겠습니까?');

      if (confirmed) {
        console.log('스타트 버튼 클릭')
        fetch('/start_circle_auto', {
          method : 'POST',
          headers: {
            'Content-Type' : 'application/json',
          },
          body: JSON.stringify({
            both_mode,
            auto_count,
            top_bottom,
            fluctuation,
            funding_rate,
            f_percent_low,
            f_percent_high,
            entry_mode,
            hedge_mode,
            leverage_info,
            sensitivity,
            atr_period,
            entry_continue,
            entry_standard,
            ema_standard,
            ema_losscut,
            candle_standard,
            candle_type_standard,
            sensitivity_standard,
            atr_period_standard,
            sensitivity_hedge,
            atr_period_hedge,
            hedge_candle,
            candle_type_hedge,
            hedge_checking,
            circle_candle,
            sensitivity_circle,
            atr_period_circle,
            candle_type_circle,
            circle_checking,
            circle_close_mode,
            sensitivity_close,
            atr_period_close,
            entry_candle,
            entry_checking,
            standard_checking,
            close_checking,
            close_mode,
            close_candle,
            direction,
            benefit_ratio,
            trigger_mode,
            trigger_ratio,
            welfare_mode,
            welfare_ratio,
            entry_usdt_1,
            double_benefit,
            circle_mode,
            circle_rate,
            candle_type_entry,
            candle_type_close
            }),
         })
         .then(response => response.json())  // 응답을 JSON 형식으로 변환
         .then(data => {
          alert(data.message);  // JSON에서 message 값을 가져옴
         })
         .catch(error => console.error('Error:', error));
       };

      onClickSearch_auto();
      // 첫 번째 실행 (1초 후)
      setTimeout(() => {
        window.location.reload();
      }, 10000); // 첫 실행까지 1초 딜레이
    };

    const onClickStart = () => {

      if (symbol === "default") {
        alert('코인을 먼저 선택하세요!');
        return; // Stop execution if the condition is met
      }
      
      let confirmed = false

      if (trade_start === 0 || trade_start === "0"){
        confirmed = window.confirm(symbol + '의 매매를 시작하시겠습니까?');
      }else if (trade_start === 1 || trade_start === "1"){
        confirmed = window.confirm(symbol + '의 셋팅값을 변경하시겠습니까?');
      }

      if (confirmed) {
        console.log('스타트 버튼 클릭')
        fetch('/start_circle', {
          method : 'POST',
          headers: {
            'Content-Type' : 'application/json',
          },
          body: JSON.stringify({
            symbol,
            entry_mode,
            hedge_mode,
            both_mode,
            leverage_info,
            sensitivity,
            atr_period,
            entry_continue,
            entry_standard,
            ema_standard,
            ema_losscut,
            candle_standard,
            candle_type_standard,
            sensitivity_standard,
            atr_period_standard,
            sensitivity_hedge,
            atr_period_hedge,
            hedge_candle,
            candle_type_hedge,
            hedge_checking,
            circle_candle,
            sensitivity_circle,
            atr_period_circle,
            candle_type_circle,
            circle_checking,
            circle_close_mode,
            sensitivity_close,
            atr_period_close,
            entry_candle,
            entry_checking,
            standard_checking,
            close_checking,
            close_mode,
            close_candle,
            direction,
            benefit_ratio,
            trigger_mode,
            trigger_ratio,
            welfare_mode,
            welfare_ratio,
            entry_usdt_1,
            double_benefit,
            circle_mode,
            circle_rate,
            candle_type_entry,
            candle_type_close,
            hedge_continue
            }),
         })
         .then(response => response.json())  // 응답을 JSON 형식으로 변환
         .then(data => {
          onClickSearch(symbol);
          alert(data.message);  // JSON에서 message 값을 가져옴
         })
         .catch(error => console.error('Error:', error));
       };
    };

    const buildCirclePresetPayload = () => ({
      entry_mode,
      hedge_mode,
      both_mode,
      leverage_info,
      sensitivity,
      atr_period,
      entry_continue,
      entry_standard,
      ema_standard,
      ema_losscut,
      candle_standard,
      candle_type_standard,
      sensitivity_standard,
      atr_period_standard,
      sensitivity_hedge,
      atr_period_hedge,
      hedge_candle,
      candle_type_hedge,
      hedge_checking,
      circle_candle,
      sensitivity_circle,
      atr_period_circle,
      candle_type_circle,
      circle_checking,
      circle_close_mode,
      sensitivity_close,
      atr_period_close,
      entry_candle,
      entry_checking,
      standard_checking,
      close_checking,
      close_mode,
      close_candle,
      direction,
      benefit_ratio,
      trigger_mode,
      trigger_ratio,
      welfare_mode,
      welfare_ratio,
      entry_usdt_1,
      double_benefit,
      circle_mode,
      circle_rate,
      candle_type_entry,
      candle_type_close,
      hedge_continue,
    });

    const applyCirclePreset = (payload = {}) => {
      if (payload.entry_mode !== undefined) setEntryMode(payload.entry_mode);
      if (payload.hedge_mode !== undefined) setHedgeMode(payload.hedge_mode);
      if (payload.both_mode !== undefined) setBothMode(payload.both_mode);
      if (payload.leverage_info !== undefined) setLeverage(payload.leverage_info);
      if (payload.sensitivity !== undefined) setSensitivity(payload.sensitivity);
      if (payload.atr_period !== undefined) setAtrPeriod(payload.atr_period);
      if (payload.entry_continue !== undefined) setEntryContinue(payload.entry_continue);
      if (payload.entry_standard !== undefined) setEntryStandard(payload.entry_standard);
      if (payload.ema_standard !== undefined) setEmaStandard(payload.ema_standard);
      if (payload.ema_losscut !== undefined) setEmaLosscut(payload.ema_losscut);
      if (payload.candle_standard !== undefined) setCandleStandard(payload.candle_standard);
      if (payload.candle_type_standard !== undefined) setCandleTypeStandard(payload.candle_type_standard);
      if (payload.sensitivity_standard !== undefined) setSensitivityStandard(payload.sensitivity_standard);
      if (payload.atr_period_standard !== undefined) setAtrPeriodStandard(payload.atr_period_standard);
      if (payload.sensitivity_hedge !== undefined) setSensitivityHedge(payload.sensitivity_hedge);
      if (payload.atr_period_hedge !== undefined) setAtrPeriodHedge(payload.atr_period_hedge);
      if (payload.hedge_candle !== undefined) setHedgeCandle(payload.hedge_candle);
      if (payload.candle_type_hedge !== undefined) setCandleTypeHedge(payload.candle_type_hedge);
      if (payload.hedge_checking !== undefined) setHedgeChecking(payload.hedge_checking);
      if (payload.circle_candle !== undefined) setCircleCandle(payload.circle_candle);
      if (payload.sensitivity_circle !== undefined) setSensitivityCircle(payload.sensitivity_circle);
      if (payload.atr_period_circle !== undefined) setAtrPeriodCircle(payload.atr_period_circle);
      if (payload.candle_type_circle !== undefined) setCandleTypeCircle(payload.candle_type_circle);
      if (payload.circle_checking !== undefined) setCircleChecking(payload.circle_checking);
      if (payload.circle_close_mode !== undefined) setCircleCloseMode(payload.circle_close_mode);
      if (payload.sensitivity_close !== undefined) setSensitivityClose(payload.sensitivity_close);
      if (payload.atr_period_close !== undefined) setAtrPeriodClose(payload.atr_period_close);
      if (payload.entry_candle !== undefined) setEntryCandle(payload.entry_candle);
      if (payload.entry_checking !== undefined) setEntryChecking(payload.entry_checking);
      if (payload.standard_checking !== undefined) setStandardChecking(payload.standard_checking);
      if (payload.close_checking !== undefined) setCloseChecking(payload.close_checking);
      if (payload.close_mode !== undefined) setCloseMode(payload.close_mode);
      if (payload.close_candle !== undefined) setCloseCandle(payload.close_candle);
      if (payload.direction !== undefined) setDirection(payload.direction);
      if (payload.benefit_ratio !== undefined) setBenefitRatio(payload.benefit_ratio);
      if (payload.trigger_mode !== undefined) setTriggerMode(payload.trigger_mode);
      if (payload.trigger_ratio !== undefined) setTriggerRatio(payload.trigger_ratio);
      if (payload.welfare_mode !== undefined) setWelfareMode(payload.welfare_mode);
      if (payload.welfare_ratio !== undefined) setWelfareRatio(payload.welfare_ratio);
      if (payload.entry_usdt_1 !== undefined) setEntryUsdt_1(payload.entry_usdt_1);
      if (payload.double_benefit !== undefined) setDoubleBenefit(payload.double_benefit);
      if (payload.circle_mode !== undefined) setCircleMode(payload.circle_mode);
      if (payload.circle_rate !== undefined) setCircleRate(payload.circle_rate);
      if (payload.candle_type_entry !== undefined) setCandleTypeEntry(payload.candle_type_entry);
      if (payload.candle_type_close !== undefined) setCandleTypeClose(payload.candle_type_close);
      if (payload.hedge_continue !== undefined) setHedgeContinue(payload.hedge_continue);
    };

  
    const onClickStop = () => {

      let confirmed = false

      confirmed = window.confirm('써클버전 자동매매를 종료하시겠습니까? 종료하시면 프로그램 자체가 종료되므로 수동으로 포지션 정리하셔야 합니다.');

      if (confirmed) {
        console.log('종료 버튼 클릭')
        fetch('/stop_circle_auto', {
          method : 'POST',
          headers: {
            'Content-Type' : 'application/json',
          },
         })
         .then(response => response.json())  // 응답을 JSON 형식으로 변환
         .then(data => {
          alert(data.message);  // JSON에서 message 값을 가져옴
         })
         .catch(error => console.error('Error:', error));
       };

      onClickSearch_auto();
      setTimeout(() => {
            window.location.reload();
          }, 10000); // 첫 실행까지 1초 딜레이
    };

    const onClickMainBalance = (symbol) => {
      const confirmed = window.confirm('메인 잔고를 조회할까요?');
      if (confirmed) {
        fetch(`/getdata_main_balance`)
          .then(async (response) => {
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
              alert(data.message || '잔고 조회 오류가 발생했습니다.');
              throw new Error('메인 잔고 조회 실패');
            }
            return data;
          })
          .then((result) => {
            console.log('main_balance에서 받아온 데이터');
            setMainBalance(result.main_balance);
          })
          .catch(() => {
            console.log('에러남');
          });
      }
    };

    const onClickSecondBalance = (symbol) => {
      const confirmed = window.confirm('2nd 잔고를 조회할까요?');
      if (confirmed) {
        fetch(`/getdata_second_balance`)
          .then(async (response) => {
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
              alert(data.message || '잔고 조회 오류가 발생했습니다.');
              throw new Error('2nd 잔고 조회 실패');
            }
            return data;
          })
          .then((result) => {
            console.log('second_balance에서 받아온 데이터');
            setSecondBalance(result.second_balance);
          })
          .catch(() => {
            console.log('에러남');
          });
      }
    };

    // 종합 익절 목표값 확인(로컬 계산)
    const onClickTotal_search = () => {
      const benefitValue = parseFloat(total_benefit_usdt);

      if (isNaN(benefitValue) || benefitValue === 0) {
        window.alert('종합 익절 값을 넣어주세요!');
        return;
      }

      if (isNaN(main_balance) || main_balance === 0) {
        window.alert('메인 잔고를 먼저 조회해주세요!');
        return;
      }

      if (both_mode === 'double' && 
        (isNaN(second_balance) || second_balance === 0)) {
        window.alert('2nd 잔고가 조회되지 않았습니다.\n더블모드 적용 시 2nd 잔고를 조회해주세요!');
        return;
      }

      const total_sum = main_balance + second_balance;
      const total_balance = total_sum + (total_sum * benefitValue / 100);

      setTotalBenefitUsdtObj(total_balance);
    };

    // 종합 익절 시작
    const onClickTotal_start = (symbol) => {
      let confirmed

      const benefitValue = parseFloat(total_benefit_usdt);

      if (isNaN(benefitValue) || benefitValue === 0) {
        confirmed = window.confirm('종합 익절 값을 넣어주세요!');
      } else if (isNaN(main_balance) || main_balance === 0) {
        confirmed = window.confirm('메인 잔고를 먼저 조회해주세요!');
      } 
      else {
        if (isNaN(second_balance) || second_balance === 0) {
          confirmed = window.confirm('2nd 잔고가 조회되지 않았습니다. 더블모드 적용시 2nd 잔고를 조회해주세요!');
        }
        confirmed = window.confirm('종합 익절을 시작할까요? 혹시라도 추가 입금시에는 종합익절을 취소한 뒤 진행하세요');
      }

      if (confirmed) {
        const total_balance = main_balance + second_balance;
        fetch(`/setdata_total_benefit_circle/${benefitValue}/${total_balance}/${total_benefit_count}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('total_benefit에서 받아온 데이터');
          // 🔹 서버에서 보내준 메시지를 사용자에게 보여주기
          if (result.message) {
            alert(result.message);
          }
          if (result?.message?.includes('시작')) {
            setTotalBenefitStart(1);
          }
          onClickSearch(symbol);
        })
        .catch((error) => {
          console.log('에러남');
          })
        };
    }

    // 종합 익절 취소 
    const onClickTotal_cancel = (symbol) => {
      const confirmed = window.confirm('종합 익절을 취소할까요?');

      if (confirmed) {
        fetch(`/setdata_total_benefit_cancel_circle`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('total_benefit_cancel에서 받아온 데이터');
          // 🔹 서버에서 보내준 메시지를 사용자에게 보여주기
          if (result.message) {
            alert(result.message);
          }
          setTotalBenefitStart(0);
          onClickSearch(symbol);
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
    }

    // 익절 후 정리
    const onClickBenefit_stop = (symbol) => {
      const confirmed = window.confirm('Do you want to clean up the selected coin after profiting?');

      if (confirmed) {
        setBenefit_stop(1);
        let urlName
        const str = symbol;
        console.log(str);
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_circle/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit에서 받아온 데이터');
          onClickSearch(symbol);
        })
        .catch((error) => {
          console.log('에러남');
          })
        };
    }

    // 익절 후 정리 취소 
    const onClickBenefit_cancel = (symbol) => {
      const confirmed = window.confirm('Do you want to cancel clearing after profiting the selected coins?');

      if (confirmed) {
        setBenefit_cancel(1);
        let urlName
        const str = symbol;
        console.log(str);
        if(str === 'default'){
          urlName = 'default'
        }else{
          const index = str.indexOf('/');
          urlName = str.substring(0,index);
        }
        fetch(`/setdata_benefit_cancel_circle/${urlName}/${setlevel}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('benefit_cancel에서 받아온 데이터');
          onClickSearch(symbol);
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
    }

    // 현재 코인 정리 
    const onClickCurrentCoin_stop = (symbol) => {
      const confirmed = window.confirm('현재 선택하신 코인의 포지션을 정리하시길 원하십니까? 포지션 정리시 약 5~10초 정도 지연될 수도 있습니다.');

      if (confirmed) {
        setCurrentCoin_stop(true);
        const str = symbol;
        console.log(str);
        const index = str.indexOf('/');
        const urlName = str.substring(0,index);
        fetch(`/setdata_current_coin_clear_circle/${urlName}/${both_mode}`)
        .then((response) => {
          if(!response.ok) {
            throw new Error('400 아니면 500 에러남');
          }
          return response.json()
        })
        .then((result) => {
          console.log('current_stop에서 받아온 데이터');
          setTimeout(() => {
            window.location.reload();
          }, 2000); // 첫 실행까지 1초 딜레이
        })
        .catch((error) => {
          console.log('에러남');
        })
      };
    }

    //로그아웃
    const onClickEnd = () => {
        const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
        if (!uuid) {
          alert('로그인 정보가 존재하지 않습니다.');
          return;
        }
        // 로그아웃 요청을 서버로 보냅니다.
        fetch('/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ userId: uuid })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('로그아웃 요청 실패');
          }
          console.log('로그아웃 성공');
          alert('Logout is successful.');
          window.location.href = '/';
        })
        .catch(error => {
          console.error('로그아웃 요청 중 오류 발생:', error);
        });
      // UUID를 서버로 보내는 예시 코드
    }

    return (
      <main className="kp-console kp-console--circle">
        <div className="kp-console__glare" aria-hidden="true" />
        <section className="kp-console__panel">
          <header className="kp-hero">
            <p className="kp-hero__eyebrow">Bitgenstone auto trade system</p>
            <h1 className="kp-hero__title">Circle cockpit</h1>
            <p className="kp-hero__subtitle">
              Circle 전략의 자동·일반 셋팅을 한 화면에서 제어하세요. UID 상태와 실시간 리스트로 포지션 흐름을 즉시 확인할 수 있습니다.
            </p>
            <div className="kp-hero__meta">
              <span className="kp-hero__uid">UID {uid || "—"}</span>
              <span>{nickname ? `${nickname}님 환영합니다` : "계정 정보를 불러오는 중"}</span>
            </div>
          </header>

          <div className="kp-console__layout">
            <div className="kp-console__main">
              <article className="kp-card kp-card--controls">
                <div className="kp-symbol-controls">
                  <div className="kp-symbol-dropdown kp-mode-dropdown" ref={modeDropdownRef}>
                    <button
                      type="button"
                      className={`kp-symbol-dropdown__trigger ${isModeMenuOpen ? "is-open" : ""}`}
                      onClick={toggleModeMenu}
                      aria-haspopup="listbox"
                      aria-expanded={isModeMenuOpen}
                    >
                      <span className="kp-symbol-dropdown__current">{currentModeLabel}</span>
                      <span className="kp-symbol-dropdown__chevron" aria-hidden="true" />
                    </button>
                    {isModeMenuOpen && (
                      <div className="kp-symbol-dropdown__menu" role="listbox">
                        {MODE_OPTIONS.map((option) => (
                          <button
                            key={option.value}
                            type="button"
                            className={`kp-symbol-dropdown__option ${option.value === mode ? "is-active" : ""}`}
                            onClick={() => handleModeSelect(option.value)}
                          >
                            {option.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="kp-symbol-dropdown" ref={symbolDropdownRef}>
                    <button
                      type="button"
                      className={`kp-symbol-dropdown__trigger ${isSymbolMenuOpen ? "is-open" : ""}`}
                      onClick={toggleSymbolMenu}
                      aria-haspopup="listbox"
                      aria-expanded={isSymbolMenuOpen}
                    >
                      <span className="kp-symbol-dropdown__current">{currentSymbolLabel}</span>
                      <span className="kp-symbol-dropdown__chevron" aria-hidden="true" />
                    </button>
                    {isSymbolMenuOpen && (
                      <div className="kp-symbol-dropdown__menu" role="listbox">
                        <button
                          type="button"
                          className={`kp-symbol-dropdown__option ${symbol === "default" ? "is-active" : ""}`}
                          onClick={() => handleSymbolSelect("default")}
                        >
                          symbol select
                        </button>
                        {selectableSymbols.length > 0 ? (
                          <>
                            <div className="kp-symbol-dropdown__divider" />
                            {selectableSymbols.map((sym) => (
                              <button
                                key={sym}
                                type="button"
                                className={`kp-symbol-dropdown__option ${sym === symbol ? "is-active" : ""}`}
                                onClick={() => handleSymbolSelect(sym)}
                              >
                                {sym}
                              </button>
                            ))}
                          </>
                        ) : (
                          <div className="kp-symbol-dropdown__empty">등록된 심볼이 없습니다</div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="kp-symbol-dropdown kp-both-dropdown" ref={bothDropdownRef}>
                    <button
                      type="button"
                      className={`kp-symbol-dropdown__trigger ${isBothMenuOpen ? "is-open" : ""}`}
                      onClick={toggleBothMenu}
                      aria-haspopup="listbox"
                      aria-expanded={isBothMenuOpen}
                    >
                      <span className="kp-symbol-dropdown__current">{currentBothModeLabel}</span>
                      <span className="kp-symbol-dropdown__chevron" aria-hidden="true" />
                    </button>
                    {isBothMenuOpen && (
                      <div className="kp-symbol-dropdown__menu" role="listbox">
                        {BOTH_MODE_OPTIONS.map((option) => (
                          <button
                            key={option.value}
                            type="button"
                            className={`kp-symbol-dropdown__option ${option.value === both_mode ? "is-active" : ""}`}
                            onClick={() => handleBothMenuSelect(option.value)}
                          >
                            {option.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="kp-symbol-controls__buttons">
                    <button onClick={handleOpenPopup} className="button_benefit_c_ut">
                      추 가
                    </button>
                    <button onClick={() => deleteSymbol(symbol)} className="button_benefit_c_ut">
                      삭 제
                    </button>
                  </div>
                </div>
                <SymbolSearchPopup
                  isOpen={isPopupOpen}
                  onAdd={handleAddSymbol}
                  onClose={handleClosePopup}
                  anchorPosition={popupAnchor}
                />
              </article>
              <AdminSharedPresetPanel
                isAdminAccess={isAdminAccess}
                featureKey="circle"
                buildPresetPayload={buildCirclePresetPayload}
                applyPreset={applyCirclePreset}
                reloadKey={`${uid}`}
                singleRow
              />

              <article className="kp-card kp-card--form">
                <div className="contentWrap_sp">

            <div className="line"></div>

            <div className="center_text_lever"style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }}>Auto mode setting</div>
              <div class="leverage_container"> 
                <div class="leverage_item" disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }}>자동코인 갯수</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                   disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }}
                  value={auto_count}
                  onChange={handleSymbolCount} />
                <div class="leverage_item" disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }}>상하위 선택</div>
                  <select className="select_samaria" value={top_bottom} 
                   disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }}onChange={handleTopBotton}>
                  <option value="top">상위</option>
                  <option value="bottom">하위</option>
                  </select>
                <div class="leverage_item" disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }}>기준등락률(%)</div>
                  <input 
                  type="number"
                  class="leverage_input_basic"
                   disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }}
                  value={fluctuation}
                  onChange={handleFluctuation} />
                </div>
                <div class="leverage_container leverage_container--funding-range">
                  <div class="leverage_item" disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }}>펀딩비율</div>
                  <select className="select_samaria" value={funding_rate}
                   disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                    }} onChange={handleFundingRate}>
                  <option value="disable">미적용</option>
                  <option value="able">적용</option>
                  </select>
                  <div class="leverage_item" disabled={mode === 'normal'}
                  style={{
                    filter: (mode === 'normal' || funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}>사이값</div>
                  <input 
                  type="number"
                  class="leverage_input_basic"
                  value={f_percent_low}
                  disabled={mode === 'normal' || funding_rate === 'disable'}
                  style={{
                    filter: (mode === 'normal' || funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleFpercentLow} />
                  <div class="leverage_item"style={{
                    filter: (mode === 'normal' || funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}>부터</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={f_percent_high}
                  disabled={mode === 'normal' || funding_rate === 'disable'}
                  style={{
                    filter: (mode === 'normal' || funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleFpercentHigh} />
                  <div class="leverage_item"style={{
                    filter: (mode === 'normal' || funding_rate === 'disable') ? 'blur(5px)' : 'none',
                    }}>까지</div>
                </div>
              
            <div className="line"></div>

            <div className="center_text_lever">Basic setting</div>
              <div class="leverage_container">
                <div class="leverage_item">진입기준</div>
                  <select className="select_samaria" value={entry_mode}
                  onChange={handleEntryMode}>
                  <option value="ut">시그널</option>
                  <option value="kinpoint">킨포인트</option>
                  </select>
                <div class="leverage_item">헷지기준</div>
                  <select className="select_samaria" value={hedge_mode}
                  onChange={handleHedgeMode}>
                  <option value="ut">시그널</option>
                  <option value="kinpoint">킨포인트</option>
                  </select>
                <div class="leverage_item">기준봉</div>
                  <select className="select_samaria" value={entry_candle}
                  onChange={handleEntryCandle}>
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                  <option value="6h">6 시간봉</option>
                  <option value="12h">12 시간봉</option>
                  <option value="1d">1 일봉</option>
                  <option value="3d">3 일봉</option>
                  <option value="1w">1 주봉</option>
                  </select>
                </div>
                <div class="leverage_container">
                <div class="leverage_item"
                style={{
                  filter: (entry_mode !== 'ut' && hedge_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}>Sensitivity</div>
                <input 
                type="number"
                class="leverage_input_basic"
                 disabled={entry_mode !== 'ut' && hedge_mode !== 'ut'}
                style={{
                  filter: (entry_mode !== 'ut' && hedge_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}
                value={sensitivity}
                onChange={handleSensitivity} />
                <div class="leverage_item" style={{
                    filter: (entry_mode !== 'ut' && hedge_mode !== 'ut') ? 'blur(5px)' : 'none',
                  }}>ATR Period</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                 disabled={entry_mode !== 'ut' && hedge_mode !== 'ut'}
                style={{
                  filter: (entry_mode !== 'ut' && hedge_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}
                value={atr_period}
                onChange={handleAtrperiod} />
              </div>
              <div className="leverage_container">
                <div class="leverage_item"style={{
                    filter: (entry_mode !== 'ut' && hedge_mode !== 'ut') ? 'blur(5px)' : 'none',
                  }} >진입/헷지 기준 캔들</div>
                <select className="select_samaria" 
                  value={candle_type_entry}
                   disabled={entry_mode !== 'ut' && hedge_mode !== 'ut'}
                    style={{
                      filter: (entry_mode !== 'ut' && hedge_mode !== 'ut') ? 'blur(5px)' : 'none',
                    }}
                  onChange={handleCandleTypeEntry}>
                  <option value="haikin">하이킨아시</option>
                  <option value="normal">일반봉</option>
                </select>
                <div class="leverage_item">진입 기준 신호 </div>
                <select className="select_samaria" 
                  value={entry_checking}
                  onChange={handleEntryChecking}>
                  <option value="-1">발생</option>
                  <option value="-2">확정</option>
                </select>
                <div class="leverage_item">헷지 기준 신호 </div>
                <select className="select_samaria" 
                  value={hedge_checking}
                  onChange={handleHedgeChecking}>
                  <option value="-1">발생</option>
                  <option value="-2">확정</option>
                </select>
              </div>
              <div className="leverage_container">
                <div class="leverage_item">트리거 모드</div>
                <select className="select_samaria" 
                  value={trigger_mode}
                  onChange={handleTriggerMode}>
                  <option value="no">미적용</option>
                  <option value="price">가격</option>
                  <option value="ratio">비율</option>
                </select>
                <div class="leverage_item" style={{
                  filter: (trigger_mode !== 'ratio') ? 'blur(5px)' : 'none',
                }}>헷지트리거(%)</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={trigger_ratio}
                  disabled={trigger_mode !== 'ratio'}
                  style={{
                    filter: (trigger_mode !== 'ratio') ? 'blur(5px)' : 'none',
                  }}
                  onChange={handleTriggerratio} />
                <div class="leverage_item">연속 진입</div>
                <select className="select_samaria" 
                  value={entry_continue} 
                  onChange={handleEntryContinue}>
                  <option value="disable">미적용</option>
                  <option value="able">적용</option>
                </select>
              </div>

              <div className="line"></div>

              <div className="leverage_container">
                <div class="leverage_item">보조 적용</div>
                <select className="select_samaria" value={entry_standard} onChange={handleEntryStandard}>
                <option value="able">적용</option>
                <option value="disable">미적용</option>
                </select>
                <div class="leverage_item" style={{
                  filter: (entry_standard !== 'able') ? 'blur(5px)' : 'none',
                }}>EMA 기준봉갯수</div>
                <input 
                type="number"
                class="leverage_input_basic"
                value={ema_standard}
                onChange={handleEmaStandard}
                disabled={entry_standard !== 'able'}
                style={{
                  filter: (entry_standard !== 'able') ? 'blur(5px)' : 'none',
                }}/>
              </div>

              <div className="leverage_container">
                <div class="leverage_item" style={{
                  filter: (entry_standard !== 'able') ? 'blur(5px)' : 'none',
                }}>보조 시간봉</div>
                <select className="select_samaria" value={candle_standard}
                disabled={entry_standard !== 'able'}
                style={{
                  filter: (entry_standard !== 'able') ? 'blur(5px)' : 'none',
                }}
                onChange={handleCandleStandard}>
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                  <option value="6h">6 시간봉</option>
                  <option value="12h">12 시간봉</option>
                  <option value="1d">1 일봉</option>
                  <option value="3d">3 일봉</option>
                  <option value="1w">1 주봉</option>
                </select>
                <div class="leverage_item" style={{
                  filter: (entry_standard !== 'able') ? 'blur(5px)' : 'none',
                }} >신호 기준</div>
                <select className="select_samaria" value={candle_type_standard}
                disabled={entry_standard !== 'able'}
                style={{
                  filter: (entry_standard !== 'able') ? 'blur(5px)' : 'none',
                }}
                onChange={handleCandleTypeStandard}>
                  <option value="haikin">하이킨아시</option>
                  <option value="normal">일반봉</option>
                </select>
              </div>

              <div className="line"></div>
              <div className="center_text_lever">Circle setting</div>
              <div class="leverage_container">
                <div class="leverage_item">순환매 익절기준</div>
                  <select className="select_samaria" value={circle_candle}
                  onChange={handleCircleCandle}>
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                  <option value="6h">6 시간봉</option>
                  <option value="12h">12 시간봉</option>
                  <option value="1d">1 일봉</option>
                  <option value="3d">3 일봉</option>
                  <option value="1w">1 주봉</option>
                  </select>
                <div class="leverage_item"style={{
                  filter: (circle_close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}>Sensitivity</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_basic"
                value={sensitivity_circle}
                disabled={circle_close_mode !== 'ut'}
                style={{
                  filter: (circle_close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}
                onChange={handleSensitivityCircle} />
                <div class="leverage_item"style={{
                  filter: (circle_close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}>ATR Period</div>
                <input 
                type="number" 
                step="1"
                class="leverage_input_basic"
                value={atr_period_circle}
                disabled={circle_close_mode !== 'ut'}
                style={{
                  filter: (circle_close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}
                onChange={handleAtrperiodCircle} />
              </div>
              <div class="leverage_container">
                <div class="leverage_item">익절 기준 타입</div>
                <select className="select_samaria" 
                  value={circle_close_mode}
                  onChange={handleCircleCloseMode}>
                  <option value="ut">시그널</option>
                  <option value="kinpoint">킨포인트</option>
                </select>
                <div class="leverage_item"style={{
                  filter: (circle_close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}>익절 기준 캔들</div>
                  <select className="select_samaria" 
                    value={candle_type_circle}
                    disabled={circle_close_mode !== 'ut'}
                    style={{
                      filter: (circle_close_mode !== 'ut') ? 'blur(5px)' : 'none',
                    }}
                    onChange={handleCandleTypeCircle}>
                    <option value="haikin">하이킨아시</option>
                    <option value="normal">일반봉</option>
                  </select>
                <div class="leverage_item">익절 기준 신호</div>
                  <select className="select_samaria" 
                    value={circle_checking}
                    onChange={handleCircleChecking}>
                    <option value="-1">발생</option>
                    <option value="-2">확정</option>
                  </select>
              </div>

              <div className="line"></div>

              <div class="leverage_container">
                <div class="leverage_item">익절기준</div>
                  <select className="select_samaria" value={close_candle}
                  onChange={handleCloseCandle}>
                  <option value="5m">5 분봉</option>
                  <option value="15m">15 분봉</option>
                  <option value="30m">30 분봉</option>
                  <option value="1h">1 시간봉</option>
                  <option value="4h">4 시간봉</option>
                  <option value="6h">6 시간봉</option>
                  <option value="12h">12 시간봉</option>
                  <option value="1d">1 일봉</option>
                  <option value="3d">3 일봉</option>
                  <option value="1w">1 주봉</option>
                  </select>
                <div class="leverage_item"style={{
                  filter: (close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}>Sensitivity</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_basic"
                value={sensitivity_close}
                disabled={close_mode !== 'ut'}
                style={{
                  filter: (close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}
                onChange={handleSensitivityClose} />
                <div class="leverage_item"style={{
                  filter: (close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}>ATR Period</div>
                <input 
                type="number" 
                step="1"
                class="leverage_input_basic"
                value={atr_period_close}
                disabled={close_mode !== 'ut'}
                style={{
                  filter: (close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}
                onChange={handleAtrperiodClose} />
              </div>
              <div class="leverage_container">
                <div class="leverage_item">익절 기준 타입</div>
                <select className="select_samaria" 
                  value={close_mode}
                  onChange={handleCloseMode}>
                  <option value="ut">시그널</option>
                  <option value="kinpoint">킨포인트</option>
                </select>
                <div class="leverage_item"style={{
                  filter: (close_mode !== 'ut') ? 'blur(5px)' : 'none',
                }}>익절 기준 캔들</div>
                  <select className="select_samaria" 
                    value={candle_type_close}
                    disabled={close_mode !== 'ut'}
                    style={{
                      filter: (close_mode !== 'ut') ? 'blur(5px)' : 'none',
                    }}
                    onChange={handleCandleTypeClose}>
                    <option value="haikin">하이킨아시</option>
                    <option value="normal">일반봉</option>
                  </select>
                <div class="leverage_item">익절 기준 신호</div>
                  <select className="select_samaria" 
                    value={close_checking}
                    onChange={handleCloseChecking}>
                    <option value="-1">발생</option>
                    <option value="-2">확정</option>
                  </select>
              </div>

              <div className="line"></div>

              <div className="leverage_container">
                <div class="leverage_item">Set Leverage</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  step="1"
                  value={leverage_info}
                  onChange={handleLeverage} />
                <div class="leverage_item">최소 익절률(%)</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={benefit_ratio}
                  onChange={handleBenefitratio} />
                <div class="leverage_item" disabled={both_mode === 'double'}
                 style={{
                  filter: (both_mode === 'double') ? 'blur(5px)' : 'none',
                }}>진입 방향 선택</div>
                  <select className="select_samaria" value={direction} onChange={handleDirection}
                  disabled={both_mode === 'double'}
                  style={{
                    filter: (both_mode === 'double') ? 'blur(5px)' : 'none',
                  }}>
                    <option value='long'>롱</option>
                    <option value='short'>숏</option>
                    <option value='auto'disabled={entry_standard !== 'able'}
                    className={entry_standard !== 'able' ? "blurred-option" : ""}>자동전환</option>
                  </select>
              </div>

              <div class="leverage_container">
                <div class="leverage_item" disabled={both_mode !== 'double'}
                 style={{
                  filter: (both_mode !== 'double') ? 'blur(5px)' : 'none',
                }}>복리 모드 선택</div>
                <select className="select_samaria" value={welfare_mode} onChange={handleWelfareMode}
                    disabled={both_mode !== 'double'}
                    style={{
                      filter: (both_mode !== 'double') ? 'blur(5px)' : 'none',
                    }}>
                    <option value='disable'>미적용</option>
                    <option value='able'>적용</option>
                  </select>
              <div className="leverage_item" disabled={both_mode !== 'double' || welfare_mode === 'disable'}
               style={{
                filter: (both_mode !== 'double' || welfare_mode === 'disable') ? 'blur(5px)' : 'none',
              }}>진입 비율(%)</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_basic"
                disabled={both_mode !== 'double' || welfare_mode === 'disable'}
                style={{
                  filter: (both_mode !== 'double' || welfare_mode === 'disable') ? 'blur(5px)' : 'none',
                }}
                value={welfare_ratio}
                onChange={handleWelfareRatio} />
              <div className="leverage_item">진입 USDT</div>
                <input
                type="number"
                step="1"
                class="leverage_input_basic"
                disabled={welfare_mode === 'able' && both_mode === 'double'}
                value={entry_usdt_1}
                onChange={handleEntryUsdt_1} />
              </div>
            <div class="leverage_container">
                <div class="leverage_item">순환매 비율(%)</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={circle_rate}
                  onChange={handleCircleRatio} />
                <div class="leverage_item">RealizedPnL</div>
                    <input 
                    type="number" 
                    class="leverage_input_basic"
                    disabled={true}
                    value={totalpnl} />
                <div class="leverage_item">헷지 연결 포지션</div>
                  <select className="select_samaria" value={hedge_continue} onChange={handleHedgeContinue}
                      disabled={mode === 'auto'}
                      style={{
                        filter: (mode === 'auto') ? 'blur(5px)' : 'none',
                        }}>
                    <option value='no'>미적용</option>
                    <option value='ok'>적용</option>
                  </select>
              </div>

            <div className="line"></div>

            <div className="center_text_lever">잔고 조회 및 종합익절 셋팅</div>
              <div class="leverage_container">
                  <div class="leverage_item">메인 잔고 조회(USDT)</div>
                  <input 
                  type="number" 
                  class="leverage_input_basic"
                  value={main_balance}
                  disabled = {true} />
                <div class="leverage_item" disabled={both_mode !== 'double'}
                    style={{
                      filter: (both_mode !== 'double') ? 'blur(5px)' : 'none',
                    }}>2nd 잔고 조회(USDT)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                style={{
                      filter: (both_mode !== 'double') ? 'blur(5px)' : 'none',
                    }}
                value={second_balance}
                disabled = {true} />
                <div class="leverage_item">총합 잔고(USDT)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={Number(main_balance + second_balance).toFixed(3)}
                disabled = {true} />
              </div>
              <div className="button_benefit_leverage button_benefit_leverage--circlepro">
                <button onClick={() => onClickMainBalance(symbol)} className="button_benefit_c_lever">
                메인 잔고 조회
                </button>
                <button onClick={() => onClickSecondBalance(symbol)} className="button_benefit_c_lever"
                  disabled={both_mode !== 'double'}
                    style={{
                      filter: (both_mode !== 'double') ? 'blur(5px)' : 'none',
                    }}>
                2nd 잔고 조회
                </button>
              </div>
              <div class="leverage_container">
                <div class="leverage_item">종합 익절 셋팅(%)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={total_benefit_usdt}
                onChange={handleTotalBenefitusdt} />
                <div class="leverage_item">종합 익절 목표값(USDT)</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={Number(total_benefit_usdt_obj).toFixed(3)}
                disabled = {true} />
              </div>
              <div class="leverage_container">
                <div class="leverage_item">종합 익절 목표 횟수</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={total_benefit_count}
                onChange={handleTotalBenefitCount} />
                <div class="leverage_item">종합 익절 현재 횟수</div>
                <input 
                type="number" 
                class="leverage_input_basic"
                value={total_current_count}
                disabled = {true} />
              </div>
              <div className="button_benefit_leverage button_benefit_leverage--circlepro">
                <button onClick={() => onClickTotal_search(symbol)} className="button_benefit_c_lever">
                종합 익절 목표값 확인
                </button>
                <button onClick={() => onClickTotal_start(symbol)} className="button_benefit_c_lever">
                종합 익절 시작
                </button>
                <button onClick={() => onClickTotal_cancel(symbol)} className="button_benefit_c_lever">
                종합 익절 취소
                </button>
              </div>
            <div className="leverage_container">
              <div
              className={`leverage_item total-benefit-status ${isTotalBenefitRunning ? 'is-running' : 'is-stopped'}`}
              >
                {isTotalBenefitRunning
                  ? '종합익절 구동중'
                  : '종합익절 정지중'}
              </div>
            </div>
            <div className="line"></div>
            <div className="line"></div>

            <OpenPositionsSnapshotSection
              endpoint="/circle_open_positions_snapshot"
              enabled={Boolean(uid)}
              reloadKey={`${uid}-${isAdminAccess ? "1" : "0"}`}
              title="메인/보조 오픈 포지션"
              updatedAtPrefix="마지막 갱신:"
              loadingRefreshLabel="조회중..."
              onSelectSymbol={onClickCoin}
              selectedSymbol={symbol}
            />
            <div className="line"></div>

            <div className="button_benefit_leverage button_benefit_leverage--circlepro">
                <button onClick={() => onClickAutoStart()} disabled={mode === 'normal'}
                style={{
                    filter: (mode === 'normal') ? 'blur(5px)' : 'none',
                  }} className="button_benefit_c_lever">
                자동 매매 시작
                </button>
                <button onClick={() => onClickStop()} className="button_benefit_c_lever">
                자동 매매 종료
                </button>
            </div>  
            <div className="button_benefit_leverage button_benefit_leverage--circlepro">    
                <button onClick={() => onClickStart()} disabled={mode === 'auto'}
                style={{
                    filter: (mode === 'auto') ? 'blur(5px)' : 'none',
                  }} className="bottomButton_sp_lever">
                일반 매매 시작
                </button>
            </div>

            <div className="button_benefit_leverage button_benefit_leverage--circlepro">
                <button onClick={() => onClickBenefit_stop(symbol)} disabled={benefit_stop === 1 || trade_start === 0 || benefit_stop === '1' || trade_start === '0'} className="button_benefit_c_lever">
                익절 후 정리
                </button>
                <button onClick={() => onClickBenefit_cancel(symbol)} disabled={benefit_stop === '0' || benefit_stop === 0} className="button_benefit_c_lever">
                취 소
                </button>
            </div>

            <div className="button_benefit_leverage button_benefit_leverage--circlepro">
                <button onClick={() => onClickCurrentCoin_stop(symbol)} disabled={(symbol === 'default' && trade_start === 0 &&  benefit_stop === 0) || (symbol === 'default' && trade_start === '0' &&  benefit_stop === '0') || setlevel <= 7} className="bottomButton_sp_lever">
                현재 코인 정리
                </button>
            </div>

            <div className="button_benefit_leverage button_benefit_leverage--circlepro">
                <button onClick={() => onClickEnd()} disabled={notAllow} className="bottomButton_sp_lever">
                로그아웃
                </button>
             </div>
                </div>
              </article>
            </div>

            <aside className="kp-console__side">
              <article className="kp-card kp-card--list">
                <div className="list_box_title_lever">진입중인 코인 리스트</div>
                <ul className="list_box_lever">
                  {e_items.map((item, index) => (
                    <li key={index} className="list_item" onClick={() => onClickCoin(item)}>
                      {item}
                    </li>
                  ))}
                </ul>
              </article>

              <article className="kp-card kp-card--list">
                <div className="list_box_title_lever">익절 후 정리 리스트</div>
                <ul className="list_box_lever">
                  {w_items.map((item, index) => (
                    <li key={index} className="list_item" onClick={() => onClickCoin(item)}>
                      {item}
                    </li>
                  ))}
                </ul>
              </article>
            </aside>
          </div>
        </section>
      </main>
    );
}